module.exports = __webpack_public_path__ + "img/training_rinks.6c16efd1.webp";